import { createElement } from 'react';

import { Providers } from '../types';

import getDisplayName from './getDisplayName';
import wrap from './wrap';

const provide = <T extends any[]>(...providers: Providers<T>) => <P>(component: React.ComponentType<P>) => {
	const Provide: React.FC<P> = props => {
		return wrap(...providers)(createElement(component, props)) as React.ReactElement<P>;
	}

	Provide.displayName = `provide(${getDisplayName(component)})`;

	return Provide;
};

export default provide;
